import SiteNav from '../../../components/SiteNav';
import { BUSINESS } from '../../../site';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen overflow-hidden">
      <SiteNav />

      {/* Hero Content */}
      <div
        id="home"
        className="relative min-h-screen flex items-center"
        style={{ paddingTop: 'clamp(84px, 9vw, 116px)', scrollMarginTop: 'clamp(84px, 9vw, 116px)' }}
      >
        {/* Background Image with Overlay */}
        <div className="absolute inset-0">
          <img
            src="/images/hero-office-1600.webp"
            srcSet="/images/hero-office-640.webp 640w, /images/hero-office-1024.webp 1024w, /images/hero-office-1600.webp 1600w"
            sizes="100vw"
            width={1600}
            height={893}
            fetchPriority="high"
            alt="Bright, spotless open-plan office with clean desks and floor-to-ceiling windows"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/[.72] via-black/[.55] to-black/[.78]"></div>
        </div>

        {/* Hero Text */}
        <div className="relative z-10 max-w-[860px] mx-auto text-center px-6">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/[.97] px-5 py-[9px] rounded-full shadow-[0_10px_24px_-10px_rgba(0,0,0,0.4)] mb-8">
            <i className="ri-shield-check-fill text-[#0b5b96]"></i>
            <h1 className="text-[13.5px] font-bold text-[#22262e]">Office &amp; Commercial Cleaning in Fredericksburg, VA</h1>
          </div>

          {/* Main Headline */}
          <p className="text-white font-extrabold leading-[1.08] tracking-tight mb-6" style={{ fontSize: 'clamp(2.75rem,5.2vw,4.25rem)' }}>
            Offices That Impress<br />Every Single Day<br />
            <span className="text-[#5FA42B]">Without the Effort</span>
          </p>

          {/* Subheadline */}
          <p className="text-[19px] text-white/[.92] leading-relaxed max-w-[600px] mx-auto mb-10">
            After-hours commercial cleaning for offices, co-working spaces, and professional workspaces. Punctual teams, spotless results, zero disruption to your business day.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap items-center justify-center gap-4">
            <button
              onClick={() => scrollToSection('contact')}
              className="group flex items-center gap-[10px] text-[#1c2410] px-[34px] py-[17px] rounded-full font-bold text-[17px] shadow-[0_14px_30px_-10px_rgba(95,164,43,0.55)] hover:shadow-[0_18px_34px_-10px_rgba(95,164,43,0.6)] hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap cursor-pointer bg-[#5FA42B] hover:bg-[#4C8A24]"
            >
              Get Free Quote
              <i className="ri-arrow-right-line"></i>
            </button>
            <a
              href={BUSINESS.phoneHref}
              className="flex items-center gap-[10px] bg-white text-[#0b5b96] px-[34px] py-[17px] rounded-full font-bold text-[17px] shadow-[0_14px_30px_-10px_rgba(0,0,0,0.35)] hover:shadow-[0_18px_34px_-10px_rgba(0,0,0,0.4)] hover:-translate-y-0.5 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-fill"></i> Call {BUSINESS.phoneDisplay}
            </a>
          </div>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-9 left-1/2 -translate-x-1/2 z-[2]">
          <i className="ri-arrow-down-line text-white/75 text-[26px]"></i>
        </div>
      </div>
    </section>
  );
}
